var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronBottomLight = function SvgChevronBottomLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.995 11.54c.236 0 .45-.1.618-.28l8.513-8.962a.75.75 0 0 0 .235-.55.76.76 0 0 0-.775-.775.8.8 0 0 0-.561.224l-8.019 8.446-8.04-8.446a.75.75 0 0 0-.551-.224.76.76 0 0 0-.775.775.8.8 0 0 0 .236.561l8.513 8.962c.18.168.37.27.606.27"
  })));
};
export default SvgChevronBottomLight;